import React from "react";

const SIZE_PX = { sm: 30, md: 34, lg: 44 };
const RADIUS = { sm: 8, md: 9, lg: 10 };

/**
 * Colored rounded-square icon chip - the repeated visual convention for KPI
 * cards, quick-action rows, and section-header icons across the Pharmacy module.
 */
const IconChip = ({ icon, color, background, size = "md", style }) => {
  const px = SIZE_PX[size] || SIZE_PX.md;
  return (
    <div
      style={{
        width: px,
        height: px,
        borderRadius: RADIUS[size] || RADIUS.md,
        background,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontSize: size === "lg" ? 20 : size === "md" ? 16 : 15,
        ...style,
      }}
    >
      {icon}
    </div>
  );
};

export default IconChip;
